import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import useRfiSendUploaderReminder from 'router/subrouters/DataRoom/hooks/useRfiSendUploaderReminder';
import { DataRoomRfiRecipient } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { useTranslation } from 'react-i18next';

import './SendReminderButton.styles.scss';

type SendReminderButtonProps = {
  className?: string;
  rfiId: string;
  email: string;
  allRecipientsWithReminders: DataRoomRfiRecipient[];
  updateAllRecipientsWithReminders: (
    allRecipientsWithReminders: DataRoomRfiRecipient[],
  ) => void;
};

const SendReminderButton: React.FC<SendReminderButtonProps> = (props) => {
  const {
    className,
    rfiId,
    email,
    allRecipientsWithReminders,
    updateAllRecipientsWithReminders,
  } = props;

  const classes = classNames('send-reminder-button', className);

  const { t } = useTranslation();

  const { isLoading, onSendReminder } = useRfiSendUploaderReminder(
    rfiId,
    allRecipientsWithReminders,
    updateAllRecipientsWithReminders,
  );

  return (
    <Button
      className={classes}
      variant="outline"
      disabled={isLoading}
      onClick={() => onSendReminder(email)}
    >
      {t('sendReminder')}
    </Button>
  );
};

export default SendReminderButton;
